module.exports = __webpack_public_path__ + "static/media/portfolioimagesidebar.16e7dceb.png";